import {
  ValidatedInput,
  ValidationMessage,
  Sidebar
} from "@/app/shared/components";
import service from "../instrumentService.js";

export default {
  props: {
    isSidebarActive: {
      type: Boolean,
      required: true
    },
    data: {
      type: Object,
      default: () => {}
    }
  },
  components: {
    ValidatedInput,
    ValidationMessage,
    Sidebar
  },
  data() {
    return {
      model: {
        id: 0,
        name: "",
        descriptionFr: "",
        descriptionEn: "",
        alternateNames: "",
        isActive: true
      }
    };
  },
  computed: {
    isSidebarActiveLocal: {
      get() {
        return this.isSidebarActive;
      },
      set(val) {
        if (!val) {
          this.$emit("closeSidebar");
        }
      }
    }
  },
  methods: {
    newData() {
      this.initValues();
      this.$refs.observer.reset();
    },
    editData() {
      this.model = structuredClone(this.data);
      this.$refs.observer.reset();
    },
    closeSidebar() {
      this.$emit("closeSidebar");
    },
    initValues() {
      if (this.data.id) return;
      this.model = {
        id: 0,
        name: "",
        descriptionFr: "",
        descriptionEn: "",
        alternateNames: "",
        isActive: true
      }
    },
    submitData() {
      this.$refs.observer.validate().then((result) => {
        if (result) {
          const domainModel = this.model;
          if (this.model.id !== null && this.model.id > 0) {
            service.edit(this, domainModel)
              .then((response) => {
                this.$emit("onUpdated", response.data.model);
              })
              .finally(() => {
                this.$vs.loading.close();
              });
          } 
          else {
            service.create(this, domainModel)
              .then((response) => {
                this.$emit("onInserted", response.data.model);
                this.model.id = response.data.companyId;
              }).finally(() => {
                this.$vs.loading.close();
              });
          }
        }
      });
    }
  }
};
